import ApiClient from '../ApiClient';

class WgptEventDefinitionsAPI extends ApiClient {
  constructor() {
    super('event_definitions', { accountScoped: true, wgpt: true });
  }
}

export default new WgptEventDefinitionsAPI();
